/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Config_HeadingInputs */



/**
* | output |
* | --- |
* | "Timer" |
*
* @param {Timer_Config_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_config_heading = /** @type {((inputs?: Timer_Config_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Config_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chronomètre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Temporizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Temporizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Timer")
	return /** @type {LocalizedString} */ ("Timer")
});